
import { faFileCircleQuestion, faLongArrowLeft } from '@fortawesome/pro-regular-svg-icons'

export default {
  name: 'PageNewsPost',

  data() {
    return {
      fetchNewsApi: new this.$ApiModel(),
      faLongArrowLeft,
      faFileCircleQuestion
    }
  },

  head() {
    return {
      title: this.compArticle.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.compArticle.summary
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: `${this.compArticle?.coverImage?.publicUrl}?height=600&width=1200&trim=${this.compArticle.imageCropTop};${this.compArticle.imageCropRight};${this.compArticle.imageCropBottom};${this.compArticle.imageCropLeft}`
        }
      ]
    }
  },

  computed: {
    compHero() {
      return {
        title: this.compArticle.title,
        image: `${this.compArticle?.coverImage?.publicUrl}?height=400&width=1700&trim=${this.compArticle.imageCropTop};${this.compArticle.imageCropRight};${this.compArticle.imageCropBottom};${this.compArticle.imageCropLeft}`,
        alt: this.compArticle.title || 'Paddock'
      }
    },

    compArticle() {
      return this.fetchNewsApi.response.data || {}
    }
  },

  created() {
    if (!this.$route.params.id) {
      this.$redirect.to('/news')

      return
    }

    this.fetchNewsById(this.$route.params.id)
  },

  methods: {
    async fetchNewsById(id) {
      try {
        await this.$api.content(this.fetchNewsApi).getPublishedContentById(id)
      } catch (error) {
        this.$log.debug('Failed to load article', error)
      }
    }
  }
}
